/*
 * KK Garment Rack — progressive enhancement for sections/kk-garment-rack.liquid.
 * Without JS every garment is a plain product link; this adds the swing-to-front
 * hover state, the name label and the <dialog> focus view (arrows, keys, swipe).
 * Quick-add forms in the focus view are submitted by kk.js ([data-quick-add]);
 * on success we close the dialog so the cart drawer is visible.
 */
(function () {
  'use strict';

  var cleanups = new WeakMap();

  function init(rack) {
    if (rack.dataset.rackReady) return;
    rack.dataset.rackReady = '1';

    var items = [].slice.call(rack.querySelectorAll('.kk-rack__item'));
    var label = rack.querySelector('[data-rack-label]');
    var hint = label ? label.textContent : '';
    var dialog = rack.querySelector('[data-rack-dialog]');
    var slides = dialog ? [].slice.call(dialog.querySelectorAll('[data-rack-slide]')) : [];
    var live = dialog && dialog.querySelector('[data-rack-live]');
    var current = -1;
    var opener = null;
    var initialItem = items[parseInt(rack.getAttribute('data-rack-initial'), 10)] || null;

    function activate(item) {
      items.forEach(function (el) { el.classList.toggle('is-active', el === item); });
      if (!label) return;
      var g = item && item.querySelector('[data-rack-name]');
      label.textContent = g ? g.getAttribute('data-rack-name') : hint;
      label.classList.toggle('is-idle', !g);
    }

    items.forEach(function (item) {
      item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') activate(item); });
      item.addEventListener('focusin', function () { activate(item); });
    });
    var list = rack.querySelector('.kk-rack__list');
    if (list) {
      // Leaving the rail returns to the merchant's "facing front on load" garment, if any.
      list.addEventListener('pointerleave', function () { activate(initialItem); });
      list.addEventListener('focusout', function (e) { if (!list.contains(e.relatedTarget)) activate(initialItem); });
    }
    if (initialItem) {
      activate(initialItem);
      // On narrow screens the rail scrolls sideways: centre the front-facing garment
      // so it is actually in view (scrollLeft only, never scrolls the page).
      var scroller = rack.querySelector('.kk-rack__scroller');
      if (scroller && scroller.scrollWidth > scroller.clientWidth) {
        var sr = scroller.getBoundingClientRect(), ir = initialItem.getBoundingClientRect();
        scroller.scrollLeft += (ir.left + ir.width / 2) - (sr.left + sr.width / 2);
      }
    }

    // Older browsers without <dialog>: leave the product links alone.
    if (!dialog || typeof dialog.showModal !== 'function' || !slides.length) return;

    function warm(i) {
      var s = slides[(i + slides.length) % slides.length];
      var img = s && s.querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    }

    function show(i, dir) {
      i = (i + slides.length) % slides.length;
      // Hiding a slide that holds focus would drop focus out of the dialog and
      // strand arrow-key navigation; hand it to the incoming slide instead.
      var active = document.activeElement;
      var refocus = active && active.closest && active.closest('[data-rack-slide]');
      slides.forEach(function (s, n) {
        s.hidden = n !== i;
        if (n === i) s.setAttribute('data-dir', dir || 1);
        var d = s.querySelector('details');
        if (d && n !== i) d.open = false;
      });
      current = i;
      if (refocus && refocus !== slides[i]) {
        var target = slides[i].querySelector('.kk-rack__name a');
        if (target) target.focus({ preventScroll: true });
      }
      warm(i + 1); warm(i - 1);
      if (live) live.textContent = slides[i].getAttribute('aria-label') + ' — ' + (slides[i].querySelector('.kk-rack__name') || {}).textContent;
    }

    function open(i) {
      opener = document.activeElement;
      show(i, 1);
      document.documentElement.classList.add('kk-rack-locked');
      dialog.showModal();
    }

    function close() { if (dialog.open) dialog.close(); }

    cleanups.set(rack, function () {
      opener = null;
      close();
      document.documentElement.classList.toggle('kk-rack-locked', !!document.querySelector('[data-rack-dialog][open]'));
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.toggle('kk-rack-locked', !!document.querySelector('[data-rack-dialog][open]'));
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    });

    rack.addEventListener('click', function (e) {
      var g = e.target.closest('[data-rack-open]');
      if (!g || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      open(parseInt(g.getAttribute('data-rack-open'), 10) || 0);
    });

    dialog.addEventListener('click', function (e) {
      var step = e.target.closest('[data-rack-step]');
      if (step) { var s = parseInt(step.getAttribute('data-rack-step'), 10); show(current + s, s); return; }
      if (e.target.closest('[data-rack-close]')) { close(); return; }
      // Clicking empty space around the garment dismisses, like the backdrop.
      if (e.target === dialog || e.target.classList.contains('kk-rack__stage') || e.target.classList.contains('kk-rack__slides')) close();
    });

    dialog.addEventListener('keydown', function (e) {
      // Arrow keys move between sizes inside a radio group; leave them alone there.
      if (e.target.type === 'radio') return;
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1, 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1, -1); }
    });

    [].forEach.call(dialog.querySelectorAll('[data-rack-buy]'), function (form) {
      function syncPrice() {
        var selected = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
        if (!selected) return;
        var slide = form.closest('[data-rack-slide]');
        var price = slide.querySelector('[data-rack-price]');
        if (price) {
          var sale = Number(selected.dataset.compareAtPrice) > Number(selected.dataset.price);
          price.querySelector('[data-rack-price-value]').textContent = selected.dataset.priceFormatted;
          price.querySelector('[data-rack-price-from]').hidden = true;
          price.querySelector('[data-rack-sale]').hidden = !sale;
          var compare = price.querySelector('[data-rack-price-compare]');
          compare.textContent = selected.dataset.compareFormatted;
          compare.hidden = !sale;
        }
        var details = form.querySelector('.kk-rack__shop');
        if (details && selected.dataset.variantUrl) details.href = selected.dataset.variantUrl;
      }
      form.addEventListener('change', syncPrice);
      syncPrice();
      form.addEventListener('kk:cart-added', function () {
        if (!dialog.open) return;
        var returnTo = opener;
        opener = null;
        close();
        if (returnTo && returnTo.isConnected && returnTo.focus) returnTo.focus({ preventScroll: true });
      });
    });

    var startX = null, startY = 0, swipePointer = null;
    dialog.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || e.isPrimary === false || e.target.closest('button, a, input, label, summary')) return;
      startX = e.clientX;
      startY = e.clientY;
      swipePointer = e.pointerId;
    });
    dialog.addEventListener('pointerup', function (e) {
      if (startX === null || e.pointerId !== swipePointer) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { var s = dx < 0 ? 1 : -1; show(current + s, s); }
    });
    dialog.addEventListener('pointercancel', function () { startX = null; swipePointer = null; });
  }

  function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-kk-rack]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Theme editor: re-init when the merchant adds or edits the section.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-kk-rack]'), function (rack) {
      var cleanup = cleanups.get(rack);
      if (cleanup) cleanup();
      cleanups.delete(rack);
    });
  });
})();
